export default {
  /** 拠点情報のstateを更新 */
  SET_EQUIPMENT_BASE_STATIONS(state, data) {
    if (!data) return;

    const index = state.equipmentBaseStations.findIndex((base) => {
      return base.hash === data.hash;
    });
    if (index === -1) {
      state.equipmentBaseStations.push(data);
    } else {
      state.equipmentBaseStations.splice(index, 1, data);
    }
  },
  /** 拠点情報をstateから除外 */
  REMOVE_EQUIPMENT_BASE_STATIONS(state, hash) {
    if (!hash) return;
    state.equipmentBaseStations = state.equipmentBaseStations.filter((base) => {
      return base.hash !== hash;
    });
  },
  /** 資材運搬船情報のstateを更新 */
  SET_EQUIPMENT_VESSELS(state, data) {
    if (!data) {
      state.equipmentVessels.splice(0, state.equipmentVessels.length);
      return;
    }

    const index = state.equipmentVessels.findIndex((vessel) => {
      return vessel.hash === data.hash;
    });
    if (index === -1) {
      state.equipmentVessels.push(data);
    } else {
      state.equipmentVessels.splice(index, 1, data);
    }
  },
  /** 資機材船舶情報をstateから除外 */
  REMOVE_EQUIPMENT_VESSELS(state, hash) {
    if (!hash) return;
    state.equipmentVessels = state.equipmentVessels.filter((vessel) => {
      return vessel.hash !== hash;
    });
  },

  /** 資機材カテゴリマスタのstateを更新 */
  SET_EQUIPMENT_CATEGORIES(state, data) {
    if (!data) {
      state.equipmentCategories.splice(0, state.equipmentCategories.length);
      return;
    }
    const index = state.equipmentCategories.findIndex((category) => {
      return category.hash === data.hash;
    });
    if (index === -1) {
      state.equipmentCategories.push(data);
    } else {
      state.equipmentCategories.splice(index, 1, data);
    }
  },

  /** 資機材カテゴリマスタ情報をstateから除外 */
  REMOVE_EQUIPMENT_CATEGORIES(state, hash) {
    if (!hash) return;
    state.equipmentCategories = state.equipmentCategories.filter((category) => {
      return category.hash !== hash;
    });
  },

  /** 出発岸壁マスタのstateを更新 */
  SET_EQUIPMENT_DEPARTURE_WHARFS(state, data) {
    if (!data) {
      state.equipmentDepartureWharfs.splice(
        0,
        state.equipmentDepartureWharfs.length,
      );
      return;
    }
    const index = state.equipmentDepartureWharfs.findIndex((departure) => {
      return departure.hash === data.hash;
    });
    if (index === -1) {
      state.equipmentDepartureWharfs.push(data);
    } else {
      state.equipmentDepartureWharfs.splice(index, 1, data);
    }
  },

  /** 出発岸壁マスタ情報をstateから除外 */
  REMOVE_EQUIPMENT_DEPARTURE_WHARFS(state, hash) {
    if (!hash) return;
    state.equipmentDepartureWharfs = state.equipmentDepartureWharfs.filter(
      (departure) => {
        return departure.hash !== hash;
      },
    );
  },

  /** 目的地マスタのstateを更新 */
  SET_EQUIPMENT_DESTINATIONS(state, data) {
    if (!data) {
      state.equipmentDestinations.splice(0, state.equipmentDestinations.length);
      return;
    }
    const index = state.equipmentDestinations.findIndex((destination) => {
      return destination.hash === data.hash;
    });
    if (index === -1) {
      state.equipmentDestinations.push(data);
    } else {
      state.equipmentDestinations.splice(index, 1, data);
    }
  },

  /** 目的地マスタ情報をstateから除外 */
  REMOVE_EQUIPMENT_DESTINATIONS(state, hash) {
    if (!hash) return;
    state.equipmentDestinations = state.equipmentDestinations.filter(
      (destination) => {
        return destination.hash !== hash;
      },
    );
  },

  /** 投入実績情報のstateを更新 */
  SET_EQUIPMENT_TYPES(state, data) {
    if (!data) {
      state.equipmentTypes.splice(0, state.equipmentTypes.length);
      return;
    }
    const index = state.equipmentTypes.findIndex((equipmentType) => {
      return equipmentType.hash === data.hash;
    });
    if (index === -1) {
      state.equipmentTypes.push(data);
    } else {
      state.equipmentTypes.splice(index, 1, data);
    }
  },
  /** 投入実績情報をstateから除外 */
  REMOVE_EQUIPMENT_TYPES(state, hash) {
    if (!hash) return;
    state.equipmentTypes = state.equipmentTypes.filter((equipmentType) => {
      return equipmentType.hash !== hash;
    });
  },

  /** 運搬航路マスタのstateを更新 */
  SET_EQUIPMENT_SEA_ROUTES(state, data) {
    if (!data) {
      state.equipmentSeaRoutes.splice(0, state.equipmentSeaRoutes.length);
      return;
    }
    const index = state.equipmentSeaRoutes.findIndex((seaRoute) => {
      return seaRoute.hash === data.hash;
    });
    if (index === -1) {
      state.equipmentSeaRoutes.push(data);
    } else {
      state.equipmentSeaRoutes.splice(index, 1, data);
    }
  },

  /** 運搬航路マスタ情報をstateから除外 */
  REMOVE_EQUIPMENT_SEA_ROUTES(state, hash) {
    if (!hash) return;
    state.equipmentSeaRoutes = state.equipmentSeaRoutes.filter((seaRoute) => {
      return seaRoute.hash !== hash;
    });
  },
  /*=========================================================================================
   リセット
  ==========================================================================================*/
  RESET_STATE(state, data) {
    Object.assign(state, data);
  },
};
